<div class="row" style="padding-bottom:200px;">
  <div class="col-md-6">
    <div class="col-md-12">
      <div *ngIf="business.status!=='HIBERNATE' && !configList['enterpriseChild']" class="col-md-12">
        <h3 style="text-align: center">{{ 'AccountSettings.hibernateTitle1' | translate }}</h3>
        <p style="text-align: center;"><span>{{ 'AccountSettings.hibernateDesc1' | translate }}</span><br><br>
          <span>{{ 'AccountSettings.hibernateDesc2' | translate }}</span>
        </p>
        <div class="clearfix clear-spacing"></div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field style="width: 100%">
              <mat-label>Reason for Hibernation</mat-label>
              <textarea matInput rows="3" [(ngModel)]="hibernateModel.reason"></textarea>
            </mat-form-field>
            <span *ngIf="noHibernationReason"><div role="alert"
                                                   class="alert alert-warning timetap-alert-spacing"><p><i
              class="fa fa-warning"></i> Please enter a reason for hibernation.</p></div></span>
            <!--<timetap-form-error *ngIf="noHibernationReason"><i class="fa fa-warning"></i> Please enter a reason for hibernation.</timetap-form-error>-->
          </div>
        </div>
        <div class="clearfix clear-spacing"></div>
        <div class="row">
          <div class="col-md-12">
            <p class="input-group">
              <mat-form-field style="width: 100%">
                <mat-label>{{ 'AccountSettings.reactivationInstructions' | translate }}
                </mat-label>
                <input matInput [matDatepicker]="hibernateReactivationDate"
                       [(ngModel)]="hibernateModel.date" [min]="tomorrow">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconPrefix
                                       [for]="hibernateReactivationDate"></mat-datepicker-toggle>
                <mat-datepicker #hibernateReactivationDate></mat-datepicker>

              </mat-form-field>
            </p>
            <div class="help-block">
                                <span *ngIf="noHibernationDate"><div role="alert"
                                                                     class="alert alert-warning timetap-alert-spacing"><p>Please enter
                                  a date when you'd like to receive reactivation instructions.</p></div></span>

            </div>
          </div>

          <div class="clearfix"></div>
          <div class="col-md-12">
            <button type="button" [disabled]="hibernating" class="btn btn-block btn-primary"
                    (click)="hibernateAccount()">
              <i class="fa fa-moon-o"></i>
              <span *ngIf="!hibernating">{{ 'btn.hibernate' | translate }}</span>
              <span *ngIf="hibernating"><i class="fa fa-spinner fa-spin fa-fw"></i> Hibernating account...</span>
            </button>
          </div>
          <div class="clearfix"></div>
          <p class="col-md-12 help-block" style="text-align: center; padding-top: 15px;">
            <strong>Important Items to Note:</strong>
          </p>
          <div class="clearfix"></div>
          <ul class="col-md-12">
            <li>If you have calendar syncing set up, it will <strong>not</strong> run during your
              account's hibernation period. When you reactivate your account, it should resume
              syncing
              but you may need to re-establish the sync if there have been any changes to the
              security
              permissions on your external calendar.
            </li>
            <li>If our pricing structure changes while your account is in hibernation status, you
              will
              be moved into our new pricing structure upon resuming your subscription. You will not
              maintain access to any legacy plans.
            </li>
            <li>If you are on an annual account, you will not be credited back the remaining amount
              of
              time on the annual payment period.
            </li>
          </ul>
        </div>
        <div class="clearfix clear-spacing"></div>

      </div>


    </div>
  </div>
  <div
    [ngClass]="{'col-md-12': business.status==='HIBERNATE' || configList['enterpriseChild'], 'col-md-6': business.status!=='HIBERNATE' && !configList['enterpriseChild']}"
    style="text-align: center;">
    <div class="col-md-12">

      <h3>{{ 'AccountSettings.hibernateTitle2' | translate }}</h3>

      <p>All good things come to an end. Please click the button below to proceed with
        cancellation.<br><br>
        <em>Once your account is cancelled, you will no longer have access to any data on it
          including
          any appointments or {{ configList['clientLabel'] }} records. Please be sure to export
          any
          data that you
          need before cancelling your account. If you think you may need to access your data at a
          later point, we recommend hibernating your account instead.</em>
      </p>

      <div class="clearfix clear-spacing"></div>
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-12">
            <a href data-toggle="modal" class="config btn btn-block btn-danger"
               (click)="cancelAccount()"><i class="fa fa-ban"></i> <span
            >{{ 'btn.cancelAccount' | translate }}</span></a>
          </div>
          <div class="col-md-3"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="clearfix clear-spacing"></div>
